/**
 * Mobile product gallery thumbnail sync.
 *
 * Purely additive: does not modify the theme's Vue product-media component.
 * Only runs when the mobile breakpoint (<=749px) matches, so it has zero
 * effect on desktop even though this file loads on every product page.
 *
 * Behavior:
 * - Clicking a thumbnail toggles a `.is-thumb-active` class (existing
 *   Vue `v-on:click="onMediaActivate"` handler still does the real slide jump;
 *   this listener is additional and does not replace it).
 * - Watches the Swiper slide's active class so swiping the main image also
 *   updates which thumbnail is highlighted.
 * - Scrolls the active thumbnail into view within the horizontal strip.
 */
(function () {
  var MOBILE_QUERY = '(max-width: 749px)';

  function setActive(thumbs, mediaId) {
    thumbs.forEach(function (t) {
      var isActive = t.getAttribute('data-media-id') === mediaId;
      t.classList.toggle('is-thumb-active', isActive);
      if (isActive && typeof t.scrollIntoView === 'function') {
        t.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      }
    });
  }

  function setup(container) {
    if (container.dataset.mobileThumbsInit === 'true') return;

    var thumbs = container.querySelectorAll('.product-medias__thumbnail');
    var slidesWrapper = container.querySelector('.swiper-wrapper');
    if (!thumbs.length || !slidesWrapper) return;

    container.dataset.mobileThumbsInit = 'true';
    var thumbList = Array.prototype.slice.call(thumbs);

    thumbList.forEach(function (t) {
      t.addEventListener('click', function () {
        setActive(thumbList, t.getAttribute('data-media-id'));
      });
    });

    function syncFromActiveSlide() {
      var activeSlide = slidesWrapper.querySelector('.swiper-slide-active');
      var mediaEl = activeSlide && activeSlide.querySelector('[data-media-id]');
      if (mediaEl) setActive(thumbList, mediaEl.getAttribute('data-media-id'));
      return !!mediaEl;
    }

    // Swiper initializes asynchronously (Vue component mount); poll briefly
    // until the active slide class appears, then rely on the observer.
    var attempts = 0;
    var poll = setInterval(function () {
      attempts++;
      if (syncFromActiveSlide() || attempts > 20) {
        clearInterval(poll);
      }
    }, 150);

    var observer = new MutationObserver(syncFromActiveSlide);
    observer.observe(slidesWrapper, {
      attributes: true,
      attributeFilter: ['class'],
      subtree: true
    });
  }

  function initAll() {
    if (!window.matchMedia(MOBILE_QUERY).matches) return;
    document.querySelectorAll('.product-medias__with-thumbnails').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  window.addEventListener('load', initAll);

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(initAll, 200);
  });
})();
